import React from 'react';

import { useIsLocalizationEnabled } from 'hooks/use-is-localization-enabled';

import LanguageSelector from '../components/language-selector';
import { ConfirmOtp } from '../confirm-otp';
import { SignIn } from '../sign-in';

import { SignUpPanel } from './sign-up-home.styled';
import { AuthenticationTabProps } from './types';

const SigninTab = React.memo(({ showOtpForm, extraFields }: AuthenticationTabProps) => {
  const isLocalizationEnabled = useIsLocalizationEnabled();

  return (
    <SignUpPanel>
      {showOtpForm ? <ConfirmOtp /> : <SignIn authCampaignExtraFields={extraFields} />}
      {isLocalizationEnabled && <LanguageSelector />}
    </SignUpPanel>
  );
});

export default SigninTab;
